// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"88":"player","118":"document-detail","264":"target","884":"admin","966":"login"}[chunkId] + "." + {"88":"e9648036","118":"a5544c12","264":"af1e630d","884":"d9b090b4","966":"7a0375b3"}[chunkId] + ".css";
};